module.exports = __webpack_public_path__ + "static/img/loading.0ed64c3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = 89
// module chunks = 4 5 6